/* PEOPLE copy shared by more than one page of ppl-ai.com. Wording is the brand's: change it
   only against the PEOPLE source site. */

export const CONTACT_EMAIL = "info@ppl-ai.com";

export const TRUST_STRIP: string[] = [
  "Role-based access",
  "Community data isolation",
  "PHI protected",
  "Every action on the record",
  "ESIGN/UETA e-signature",
  "Escalation by policy",
];

export interface LiveCommunities {
  kicker: string;
  headline: string;
  inProduction: string;
}

export const LIVE_COMMUNITIES: LiveCommunities = {
  kicker: "Live communities",
  /* Present tense and no future-facing hedge: the panel found that framing this
     as a cohort being formed reads as risk rather than candour. */
  headline: "Running in production today.",
  inProduction: "Live in production at Reunion Inn Assisted Living and Pine Lodge Assisted Living.",
};
